import request  from './axiosUtil'
import qs from 'qs';

export function getRequest(uri, params) {
  return request.get(uri,qs.stringify(params));
}

export function postRequest(uri, params) {
  return request.post(uri,qs.stringify(params));
}

export function deleteRequest(uri, params) {
  return request({
    url: uri,
    method: 'delete',
    params: qs.stringify(params)
  })
}

export function putRequest(uri, params) {
  return request({
    url: uri,
    method: 'put',
    data: qs.stringify(params)
  })
}



// WEBPACK FOOTER //
// ./src/utils/axois.js